import moment from '../../../lib/moment';
import { _LIST_PAGINATION_MODEL, LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../app/models';
import { COUPON_INFO_TAB_INDEX } from '../../../constants/service/app/couponConstants';

/**
 *  쿠폰 리스트 검색 박스 모델
 */
export const COUPON_LIST_SEARCH_DATA_MODEL = {
  /**
   *  발급 가능한 쿠폰
   */
  couponAvailability: false,
};

/**
 *  쿠폰 리스트 검색 옵션 모델
 */
export const COUPON_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  발급 가능한 쿠폰
   */
  couponAvailability: false,
};

/**
 *  쿠폰 리스트 필터 옵션 모델
 */
export const COUPON_LIST_FILTER_OPTION_MODEL = {
  /**
   *  쿠폰 ID
   */
  couponId: null,
  /**
   *  쿠폰명
   */
  name: null,
  /**
   *  쿠폰 설명
   */
  description: null,
  /**
   *  쿠폰 상태
   */
  status: null,
  /**
   *  쿠폰 다운로드 가능 여부
   */
  isDownloadable: 0,
  /**
   *  쿠폰 유형
   */
  availableType: null,
  /**
   *  쿠폰 할인 타입
   */
  discountType: null,
  /**
   *  쿠폰 코드
   */
  code: null,
  /**
   *  생성일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  쿠폰 리스트 정렬 옵션 모델
 */
export const COUPON_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  쿠폰 발급 내역 리스트 검색 박스 모델
 */
export const COUPON_ISSUE_HISTORY_LIST_SEARCH_DATA_MODEL = {
  /**
   *  발급 내역 id
   */
  couponIssueHistoryId: null,
  /**
   *  발급한 관리자 리스트
   */
  adminIdList: [],
  /**
   *  메모
   */
  memo: null,
  /**
   *  쿠폰 발급 데이터 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  쿠폰 발급 내역 리스트 검색 박스 모델
 */
export const COUPON_ISSUE_HISTORY_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  발급 내역 id
   */
  couponIssueHistoryId: null,
  /**
   *  발급한 관리자 리스트
   */
  adminIdList: [],
  /**
   *  메모
   */
  memo: null,
  /**
   *  쿠폰 발급 데이터 생성일
   */
  createDate: null,
};

/**
 *  쿠폰 발급 내역 상세 필터 옵션 모델
 */
export const COUPON_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL = {
  isUsed: null,
};

/**
 *  쿠폰 발급 내역 상세 정렬 옵션 모델
 */
export const COUPON_ISSUE_HISTORY_DETAIL_SORT_OPTION_MODEL = {
  /**
   *  유저 id
   */
  userId: 'descend',
  /**
   *  쿠폰 id
   */
  couponId: null,
};

/**
 *  쿠폰 적용 가능 상품에 연결할 아이템 리스트 필터 모델
 */
export const COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 번호
   */
  storeId: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  상품 번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
};

/**
 *  쿠폰 적용 가능 상품에 연결할 아이템 리스트 정렬 모델
 */
export const COUPON_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL = {
  /**
   *  상품 생성일
   */
  createDate: null,
};

/**
 *  쿠폰 적용 가능 브랜드에 연결할 브랜드 리스트 필터 모델
 */
export const COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 번호
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
};

/**
 *  쿠폰 정보 모델
 */
export const COUPON_INFO_MODEL = {
  /**
   *  쿠폰 ID
   */
  couponId: null,
  /**
   *  쿠폰명
   */
  name: null,
  /**
   *  쿠폰 유형
   */
  availableType: 0,
  /**
   *  쿠폰 코드
   */
  code: null,
  /**
   *  쿠폰의 기간 타입
   */
  periodType: 0,
  /**
   *  쿠폰의 할인 타입
   */
  discountType: 0,
  /**
   *  할인 타입에 따른 혜택 수치
   */
  discountAmount: 10,
  /**
   *  최소 구매 금액
   */
  minimumPurchasePrice: 9000,
  /**
   *  최대 할인 가능 금액
   */
  maxDiscountPrice: 2000,
  /**
   *  24k 제외 여부
   */
  exclude24k: false,
  /**
   *  쿠폰에 대한 설명
   */
  description: null,
  /**
   *  쿠폰 유효기간
   */
  period: {
    startDate: moment(),
    endDate: moment().add(10, 'day'),
  },
  /**
   *  시작일로부터 +며칠 인지
   */
  dayPlus: 0,
  /**
   *  쿠폰에 대한 메모
   */
  memo: null,
  /**
   *  제한 횟수 타입
   */
  generateLimitType: 0,
  /**
   *  발급 제한 횟수
   */
  generateLimitCount: 1,
  /**
   *  발급 제한 기간 날짜
   */
  generateLimitDay: 1,
  /**
   *  쿠폰 상태
   */
  status: 1,
  /**
   *  쿠폰 다운로드 가능 여부
   */
  isDownloadable: 0,

  /** 추가. 쿠폰 분담률 (없으면 null) */
  settlementShare: {
    shareType: 'amount',
    shareAmount: 0,
  },
};

/**
 *  쿠폰 적용 가능 상품 아이템 정보 모델
 */
export const COUPON_PRODUCT_LINK_INFO_MODEL = {
  /**
   *  쿠폰 적용 가능 상품에 연결할 아이템 리스트
   */
  itemList: {
    /**
     * 리스트
     */
    list: [],
    /**
     *  필터 옵션
     */
    filterOption: COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션
     */
    sortOption: COUPON_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
    /**
     * pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
  /**
   *  쿠폰 적용 가능 상품에 연결할 아이템 리스트
   */
  selectedItemList: {
    list: [],
    idList: [],
  },
  /**
   *  쿠폰 적용 가능 상품들의 브랜드 갯수
   */
  selectedItemBrandCount: 0,
};

/**
 *  쿠폰 적용 가능 브랜드 정보 모델
 */
export const COUPON_BRAND_LINK_INFO_MODEL = {
  /**
   *  쿠폰 적용 가능 브랜드에 연결할 아이템 리스트
   */
  itemList: {
    /**
     * 리스트
     */
    list: [],
    /**
     *  필터 옵션
     */
    filterOption: COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL,
    /**
     * pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
  /**
   *  쿠폰 적용 가능 브랜드에 연결할 아이템 리스트
   */
  selectedItemList: {
    list: [],
    idList: [],
  },
};

/**
 *  쿠폰 통계 모델
 */
export const COUPON_STATISTICS_MODEL = {
  /**
   *  발급된 쿠폰 수
   */
  issued: 0,
  chartData: [
    {
      key: 'used',
      name: '쿠폰 사용',
      value: 0,
    },
    {
      key: 'unUsed',
      name: '쿠폰 미사용',
      value: 0,
    },
  ],
};

/**
 *  쿠폰 사용내역 리스트 필터 옵션 모델
 */
export const COUPON_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  쿠폰을 사용한 유저 이름
   */
  userName: null,
  /**
   *  쿠폰을 사용한 아이디
   */
  userAccount: null,
  /**
   *  쿠폰이 사용된 상품 주문번호
   */
  orderItemId: null,
};

/**
 *  쿠폰 미사용내역 리스트 필터 옵션 모델
 */
export const COUPON_UN_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  쿠폰을 사용하지 않은 유저 이름
   */
  userName: null,
  /**
   *  쿠폰을 사용하지 않은 아이디
   */
  userAccount: null,
};

/**
 *  쿠폰 사용내역 리스트 정렬 옵션 모델
 */
export const COUPON_USAGE_HISTORY_LIST_SORT_OPTION_MODEL = [{}];

/**
 *  쿠폰 사용내역 모델
 */
export const COUPON_USAGE_HISTORY_MODEL = {
  /**
   *  리스트
   */
  list: [],
  /**
   *  필터 옵션
   */
  filterOption: COUPON_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL,
  /**
   *  정렬 옵션
   */
  sortOption: COUPON_USAGE_HISTORY_LIST_SORT_OPTION_MODEL,
  /**
   *  리스트 pagination
   */
  pagination: LIST_PAGINATION_MODEL,
  /**
   *  집계 데이터
   */
  summary: LIST_SUMMARY_MODEL,
};

/**
 *  쿠폰 미사용내역 모델
 */
export const COUPON_UN_USAGE_HISTORY_MODEL = {
  /**
   *  리스트
   */
  list: [],
  /**
   *  리스트 filterOption
   */
  filterOption: COUPON_UN_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL,
  /**
   *  리스트 pagination
   */
  pagination: _LIST_PAGINATION_MODEL,
};

/**
 *  쿠폰 발급받을 유저 리스트 필터 옵션 모델
 */
export const COUPON_GENERATE_USER_FILTER_OPTION_MODEL = {
  /**
   *  회원번호 or 전화번호
   */
  searchType: {
    type: 0,
    value: null,
  },
  /**
   *  쿠폰 발급받을 유저 이름
   */
  name: null,
  /**
   *  쿠폰 발급받을 유저 아이디
   */
  account: null,
  /**
   *  쿠폰 발급받을 유저의 상태
   */
  status: null,
  /**
   *  쿠폰 발급받을 유저의 가입날짜
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  쿠폰 선택 모달 모델
 */
export const COUPON_SEARCH_MODAL_MODEL = {
  /**
   *  쿠폰 리스트
   */
  list: [],
  /**
   *  필터 옵션
   */
  filterOption: COUPON_LIST_FILTER_OPTION_MODEL,
  /**
   *  정렬 옵션
   */
  sortOption: COUPON_LIST_SORT_OPTION_MODEL,
  /**
   *  리스트 pagination
   */
  pagination: LIST_PAGINATION_MODEL,
  /**
   *  집계 데이터
   */
  summary: LIST_SUMMARY_MODEL,
};

/**
 *  쿠폰 상세에서 쿠폰 사용 가능한 상품 탭 테이블 모델
 */
export const COUPON_PRODUCT_LINK_ITEM_LIST_MODEL = {
  /**
   *  리스트
   */
  list: [],
  /**
   *  리스트 filterOption
   */
  filterOption: COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
  /**
   *  리스트 pagination
   */
  pagination: _LIST_PAGINATION_MODEL,
};

/**
 *  쿠폰 상세에서 쿠폰 사용 가능한 브랜드 탭 테이블 모델
 */
export const COUPON_BRAND_LINK_ITEM_LIST_MODEL = {
  /**
   *  리스트
   */
  list: [],
  /**
   *  리스트 filterOption
   */
  filterOption: COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL,
  /**
   *  리스트 pagination
   */
  pagination: _LIST_PAGINATION_MODEL,
};

/**
 *  쿠폰 등록 모델
 */
export const COUPON_CREATE_MODEL = {
  /**
   *  탭 currentTabKey
   */
  currentTabKey: COUPON_INFO_TAB_INDEX,

  /**
   *  쿠폰 정보
   */
  couponInfo: COUPON_INFO_MODEL,

  /**
   *  쿠폰 적용 가능 상품 아이템 정보
   */
  couponProductLinkInfo: COUPON_PRODUCT_LINK_INFO_MODEL,

  /**
   *  쿠폰 적용 가능 브랜드 정보
   */
  couponBrandLinkInfo: COUPON_BRAND_LINK_INFO_MODEL,

  /**
   *  상품 1차 카테고리
   */
  mainProductCategorySelectList: [],
  /**
   *  상품 2차 카테고리
   */
  subProductCategorySelectList: { null: [] },
};

/**
 *  쿠폰 상세 모델
 */
export const COUPON_DETAIL_MODEL = {
  /**
   *  쿠폰 정보
   */
  couponInfo: COUPON_INFO_MODEL,

  /**
   *  쿠폰 통계 데이터
   */
  couponStatistics: COUPON_STATISTICS_MODEL,

  /**
   *  쿠폰 사용내역
   */
  couponUsageHistory: COUPON_USAGE_HISTORY_MODEL,

  /**
   *  쿠폰 미사용내역
   */
  couponUnUsageHistory: COUPON_UN_USAGE_HISTORY_MODEL,

  /**
   *  쿠폰 적용 가능 상품
   */
  couponProductLink: COUPON_PRODUCT_LINK_ITEM_LIST_MODEL,

  /**
   *  쿠폰 적용 가능 브랜드
   */
  couponBrandLink: COUPON_BRAND_LINK_ITEM_LIST_MODEL,

  /**
   *  상품 1차 카테고리
   */
  mainProductCategorySelectList: [],
  /**
   *  상품 2차 카테고리
   */
  subProductCategorySelectList: { null: [] },
};

/**
 *  쿠폰 발급 모델
 */
export const COUPON_GENERATE_MODEL = {
  /**
   *  발급할 쿠폰 테이블
   */
  couponList: {
    /**
     *  발급할 쿠폰 리스트
     */
    issuedCouponList: [],
    /**
     *  선택된 발급할 쿠폰 리스트
     */
    selectedCouponIdList: [],
    /**
     *  선택된 발급할 쿠폰 정보 리스트(발급 수량, id)
     */
    selectedCouponInfoList: [],
  },

  /**
   *  쿠폰 발급받을 유저 테이블
   */
  issuedUser: {
    /**
     *  쿠폰 발급받을 유저
     */
    userList: {
      /**
       *  리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: COUPON_GENERATE_USER_FILTER_OPTION_MODEL,
      /**
       *  리스트 pagination
       */
      pagination: LIST_PAGINATION_MODEL,
      /**
       *  집계 데이터
       */
      summary: LIST_SUMMARY_MODEL,
    },
    /**
     *  선택된 쿠폰 발급받을 유저 리스트
     */
    selectedUserIdList: [],
    /**
     *  선택된 쿠폰 발급받을 유저 정보 리스트,
     */
    selectedUserInfoList: [],
  },
};
